import { useCallback, useMemo } from "react";
import { ListItem, Typography } from "@mui/material";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Navigation, NavigationItem, NavigationPageItem } from "@toolpad/core/AppProvider";
import { DashboardSidebarPageItem } from "@toolpad/core/DashboardLayout";

import { RootState } from "@store/store";
import { BaseLayout } from "@layouts/BaseLayout";
import { useTokenExpirationGuard } from "@hooks/useTokenExpirationGuard";

export const AdminLayout = () => {
    const location = useLocation();

    const permissions = useSelector((state: RootState) => state.session.permissions);
    const applicationLoaded = useSelector((state: RootState) => state.components.applicationSelected);
    const lockMenuApplication = useSelector((state: RootState) => state.components.menuApplication.lock);

    useTokenExpirationGuard();

    const navigationOptions: Navigation = useMemo(() => {
        let options: NavigationItem[] = [];

        if (permissions.find((t) => t.module.code === "SBUSERS")) {
            options.push({
                segment: "admin/usuarios",
                title: "Usuarios",
            });
        }
        if (permissions.find((t) => t.module.code === "SBROL")) {
            options.push({
                segment: "admin/roles",
                title: "Roles",
            });
            options.push({
                kind: "divider",
            });
        }
        if (permissions.find((t) => t.module.code === "SBCMPN")) {
            options.push({
                segment: "admin/companias",
                title: "Compañías",
            });
        }
        if (permissions.find((t) => t.module.code === "SBFINAN")) {
            options.push({
                segment: "admin/financieras",
                title: "Financieras",
            });
            options.push({
                kind: "divider",
            });
        }
        if (permissions.find((t) => t.module.code === "SBCOAT")) {
            options.push({
                segment: "admin/codigos_atribucion",
                title: "Códigos de Atribución",
            });
        }
        if (permissions.find((t) => t.module.code === "SBESAT")) {
            options.push({
                segment: "admin/estructura_atribucion",
                title: "Estructura Atribución",
            });
            options.push({
                kind: "divider",
            });
        }
        if (permissions.find((t) => t.module.code === "SBARREV")) {
            options.push({
                segment: "admin/abortivos_revision",
                title: "Reglas de Admisión",
            });
            options.push({
                kind: "divider",
            });
        }
        if (permissions.find((t) => t.module.code === "SBRARFI")) {
            options.push({
                segment: "admin/abortivos_revision_financieras",
                title: "Reglas Adm. Finan.",
            });
            options.push({
                kind: "divider",
            });
        }
        if (permissions.find((t) => t.module.code === "SBLOAC")) {
            options.push({
                segment: "admin/log_actividad",
                title: "Log Actividad",
            });
            options.push({
                kind: "divider",
            });
        }
        if (permissions.find((t) => t.module.code === "SBREGRAL")) {
            options.push({
                segment: "admin/general",
                title: "General",
            });
        }
        if (permissions.find((t) => t.module.code === "SBRESOL")) {
            options.push({
                segment: "admin/solicitudes",
                title: "Solicitudes",
            });
            options.push({
                kind: "divider",
            });
        }
        if (permissions.find((t) => t.module.code === "SBEPET")) {
            options.push({
                segment: "admin/encargados_etapa",
                title: "Encargados por Etapa",
            });
        }

        return options;
    }, [location.pathname]);

    const handleRenderPageItem = useCallback(
        (item: NavigationPageItem, { mini }: { mini: boolean }) => {
            if (item.segment?.startsWith("header")) {
                return (
                    <ListItem sx={{ justifyContent: "center", p: 0 }}>
                        <Typography component={"span"} variant="h5" sx={{
                            color: "main2",
                            fontWeight: 300
                        }}>
                            {mini === false && `ID Solicitud: `}
                            <Typography component={"span"} variant="h5" sx={{
                                color: "main2",
                                fontWeight: 600
                            }}>
                                {applicationLoaded.id_application_company?.toString().padStart(5, "0")}
                            </Typography>
                        </Typography>
                    </ListItem>
                );
            }

            return <DashboardSidebarPageItem item={item} disabled={false} />;
        },
        [applicationLoaded.id, location.pathname, lockMenuApplication],
    );

    return (
        <BaseLayout
            navigation={navigationOptions}
            renderPageItem={handleRenderPageItem}
        />
    );
};
